import React from 'react';
import { Link } from 'react-router-dom';
import SiteNav from './components/SiteNav';
import './App.css';

function PrivacyPage() {
  return (
    <div
      className="App index-page"
      style={{
        backgroundImage: `url('/background/background.png')`,
        backgroundColor: '#f0f0f0'
      }}
    >
      <SiteNav />
      <header className="App-header index-header">
        <div className="index-panel info-panel">
          <h2 className="index-title">Privacy Policy</h2>
          <p className="index-subtitle">Last updated: September 27, 2026</p>

          <div className="info-prose">
            <h3>Overview</h3>
            <p>
              Best Audio Books For Free respects your privacy. This site is designed to let you
              browse and listen to free audiobooks without requiring an account or personal
              information from visitors.
            </p>

            <h3>Personal Data</h3>
            <p>
              You can browse this website without creating an account or providing personal information. If you contact us by email, we receive and handle the information you provide as described under ‘Support Emails’ below. For technical information processed by our hosting providers, see ‘Technical & Hosting Information.
            </p>

            <h3>What We Do Not Collect</h3>
            <ul>
              <li>Payment or billing information</li>
              <li>Account credentials from public users</li>
              <li>Browsing profiles built for advertising or resale</li>
            </ul>

            <h3>Support Emails</h3>
            <p>
              If you email us for website or Mansfieldian app support, we receive your email address and any information you include. We use this information to respond to your request and delete the email correspondence after responding. You may request deletion by emailing bestaudiobooksforfree@gmail.com.
            </p>

            <h3>Technical &amp; Hosting Information</h3>
            <p>
              Like most websites, our hosting and content delivery providers may automatically
              process limited technical information needed to operate the service securely — for
              example IP address, browser type, and basic request logs. This information is used
              only for reliability, security, and performance, not to identify you personally or
              market to you.
            </p>

            <h3>Cookies &amp; Local Storage</h3>
            <p>
              The public site does not use tracking or advertising cookies. Temporary browser
              storage may be used only as needed for basic site functionality (such as admin
              session details for authorized administrators).
            </p>

            <h3>Third-Party Links</h3>
            <p>
              Audiobook pages may link to third-party platforms such as YouTube or Rumble. Those
              services have their own privacy practices. We are not responsible for the content
              or privacy policies of sites we link to.
            </p>

            <h3>Children&apos;s Privacy</h3>
            <p>
              This website is not directed at collecting information from children. We do not knowingly collect personal information from children under 13. If you believe a child has provided personal information to us by email, please contact bestaudiobooksforfree@gmail.com so we can delete it.
            </p>

            <h3>Changes to This Policy</h3>
            <p>
              We may update this privacy policy from time to time. Any changes will be posted on
              this page with an updated date.
            </p>

            <h3>Mansfieldian App Privacy</h3>
            <p>
              Mansfieldian is provided by Bestaudiobooksforfree, LLC. The app requires no account and does not collect or transmit personal data to us. It contains no advertising or analytics tracking.
Your Special Days and preferences are stored locally on your device. The app does not automatically synchronize them between devices. You can delete individual Special Days within the app.
When you open an external website using an app link, that website’s privacy policy applies. If you email support, we receive your email address and the information you include. For privacy questions, please visit our{' '}
              <Link to="/support">Support</Link> page.
            </p>

            <h3>Mansfieldian Privacy Policy</h3>
            <p>
              This policy applies to the Mansfieldian iPhone and iPad app published by Bestaudiobooksforfree, LLC.
            </p>

            <h3>Information within the app</h3>
            <p>
              Mansfieldian does not collect or transmit personal information to us. It does not require an account and does not include advertising, tracking, or third-party analytics.
Personal Special Days and preferences are stored locally on your device. The app does not automatically synchronize them between devices. Device backups may include this information according to your Apple settings.
You can remove individual Special Days within the app. Deleting the app removes its local data; backup copies are managed through your device and backup settings.
            </p>

            <h3>Contacting support</h3>
            <p>
              If you email us, we receive your email address and whatever information you choose to send. We use this information to respond and resolve your request. Our email provider processes those messages to deliver and store them.
We retain support correspondence only as needed to handle your request and meet applicable obligations. You may request deletion by contacting us.
            </p>

            <h3>External websites</h3>
            <p>
              Links opened from the app lead to external websites with their own privacy practices. This policy describes the Mansfieldian app, not data collected independently by those websites or by the audiobook website.
            </p>

            <h3>Contact and updates</h3>
            <p>
              If you have questions about this privacy policy or deletion requests, please visit our{' '}
              <Link to="/support">Support</Link> page.
            </p>
            <p>We will update this policy when the app’s privacy practices change.</p>
          </div>
        </div>
      </header>
    </div>
  );
}

export default PrivacyPage;
